document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
const contactPosted = urlParams.get('cfp_success');

  const popup = document.getElementById('call-for-price-popup');
  if (!popup) return;

  const openButtons = document.querySelectorAll('[data-open-call-for-price]');
  const closeButton = popup.querySelector('.cfp-popup__close');
  const overlay = popup.querySelector('.cfp-popup__overlay');
  const successMessage = popup.querySelector('.cfp-success-message');
  const form = popup.querySelector('form');

  function openPopup() {
    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.setAttribute('hidden', true);
    document.body.style.overflow = '';
  }

  // 👉 فتح تلقائي بعد إرسال الفورم
  if (contactPosted === 'true') {
    openPopup();

    if (successMessage) successMessage.removeAttribute('hidden');
    if (form) form.style.display = 'none';

    // إغلاق تلقائي بعد 3 ثواني (اختياري)
    setTimeout(closePopup, 3000);
  }

  // فتح يدوي من الزر
  openButtons.forEach(btn => {
    btn.addEventListener('click', openPopup);
  });

  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }
});
